import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PolicyList({ policies, loading, selectedPolicy, onSelectPolicy, onQuickTest, onRefresh }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "border border-border rounded-lg p-4 bg-card",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-xl font-semibold text-card-foreground",
                        children: "Active Policies"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onRefresh,
                        disabled: loading,
                        className: "px-3 py-1 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 disabled:opacity-50 transition-colors",
                        children: loading ? 'Loading...' : 'Refresh'
                    })
                ]
            }),
            loading && policies.length === 0 ? /*#__PURE__*/ _jsx("div", {
                className: "text-center py-8 text-muted-foreground",
                children: "Loading policies..."
            }) : policies.length === 0 ? /*#__PURE__*/ _jsx("div", {
                className: "text-center py-8 text-muted-foreground",
                children: "No policies found. Policies are loaded from the file system."
            }) : /*#__PURE__*/ _jsx("div", {
                className: "space-y-3",
                children: policies.map((policy)=>/*#__PURE__*/ _jsxs("div", {
                        className: `border rounded-lg p-3 transition-all ${selectedPolicy?.id === policy.id ? 'bg-primary/10 border-primary shadow-sm' : 'bg-card border-border hover:bg-muted/50'}`,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "font-medium text-card-foreground",
                                        children: policy.name
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: [
                                            policy.kind,
                                            " • v",
                                            policy.version
                                        ]
                                    }),
                                    policy.description && /*#__PURE__*/ _jsx("div", {
                                        className: "text-sm text-muted-foreground mt-1",
                                        children: policy.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex space-x-2",
                                children: [
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        onClick: ()=>onQuickTest(policy.name),
                                        className: "px-2 py-1 text-xs bg-accent text-accent-foreground rounded hover:bg-accent/90 transition-colors",
                                        children: "Quick Test"
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        onClick: ()=>onSelectPolicy(policy),
                                        className: "px-2 py-1 text-xs bg-secondary text-secondary-foreground rounded hover:bg-secondary/90 transition-colors",
                                        children: "View Details"
                                    })
                                ]
                            })
                        ]
                    }, policy.id))
            })
        ]
    });
}
